// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { Note } from '../../../types/Model';

export interface OnlineCourseNotesRequestPayload {
  id: number;
}
export interface OnlineCourseNotesSuccessPayload {
  id: number;
  notes: Note[];
}

export interface OnlineCourseNotesFailPayload {
  error: Error;
}

const getOnlineCourseNotesDataActions = createAsyncAction(
  'elearning/GET_ONLINE_COURSE_NOTES_DATA',
  'elearning/GET_ONLINE_COURSE_NOTES_DATA_SUCCESS',
  'elearning/GET_ONLINE_COURSE_NOTES_DATA_FAIL'
)<
  OnlineCourseNotesRequestPayload,
  OnlineCourseNotesSuccessPayload,
  OnlineCourseNotesFailPayload
>();

export { getOnlineCourseNotesDataActions as default }
